import React from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const Greetings = () => {

    return (
        <Card className="mb-1 p-2">
            <Row className="g-2 align-items-sm-center">
                <Col>
                    <h5>
                        Lista de Facturas
                    </h5>
                </Col>
                <Col className="col-auto">
                    <Link to="/contabilidad/FormularioFactura/:id">
                        <Button size="sm"
                            variant="falcon-primary"
                        >Nueva Factura</Button>
                    </Link>
                </Col>

            </Row>
        </Card>
    );
};




export default Greetings;
